import React, { useEffect, useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Stack, Typography } from '@mui/material';
import { debounce, map } from 'lodash';
import { size } from 'lodash';

import { Props, RulesStackProps } from './props';
const PasswordVerifyView: React.FC<Props> = (props) => {
  const {
    password,
    title = 'Password must:',
    rulesBoxProps,
    rulesTitleProps,
    titleProps,
    containerProps,
    iconSize = 14,
    ...rest
  } = props;

  // ============ STATE
  const [isLengthValid, setIsLengthValid] = useState(false);
  const [hasUppercase, setHasUppercase] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasSpecialChar, setHasSpecialChar] = useState(false);

  // ============ HELPER FUNCTION
  const validatePassword = debounce((value) => {
    setIsLengthValid(size(value) >= 8);
    setHasUppercase(/[A-Z]/.test(value));
    setHasNumber(/\d/.test(value));
    setHasSpecialChar(/[^A-Za-z0-9]/.test(value));
  }, 400);

  // ============ EFFECTS
  useEffect(() => {
    validatePassword(password);
  }, [password, validatePassword]);

  // ============ VARIABLES
  const rules = [
    {
      cond: isLengthValid,
      text: 'Have a minimum 8 characters',
    },
    {
      cond: hasNumber,
      text: 'Contains a number',
    },
    {
      cond: hasUppercase,
      text: 'Contains an uppercase letter',
    },
    {
      cond: hasSpecialChar,
      text: 'Contains special characters',
    },
  ];

  // ============ VIEW

  const renderRulesStack = ({ cond, text }: RulesStackProps) => {
    return (
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'row',
          xs: 'span 12',
          md: 'span 6',
          gap: 2.5,
        }}
        {...rulesBoxProps}
      >
        <CheckCircleIcon
          color={cond ? 'success' : 'disabled'}
          sx={{
            fontSize: iconSize,
            marginTop: '2px',
          }}
        />
        <Typography sx={{ fontSize: 12 }} {...rulesTitleProps}>
          {text}
        </Typography>
      </Stack>
    );
  };

  return (
    <Box {...rest}>
      <Typography
        className="uppercase"
        sx={{
          letterSpacing: 1,
          fontSize: 12,
          fontWeight: 500,
        }}
        {...titleProps}
      >
        {title}
      </Typography>
      <Box className="grid grid-cols-1 md:grid-cols-2" {...containerProps}>
        {map(rules, (rule, i) => {
          const { cond, text } = rule;
          return (
            <React.Fragment key={i}>
              {renderRulesStack({ cond, text })}
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
};

export const PasswordVerify = PasswordVerifyView;
export default PasswordVerifyView;
